import { uploadWarrantComponent } from './uploadWarrant.component';
import { transferringStateName } from '../../../tickets.state';
import { TicketService } from '../../../../ticket/ticket.service';

export const uploadWarrantStateName = `${transferringStateName}.uploadWarrant`;

export const uploadWarrantState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: uploadWarrantStateName,
    url: '/upload/:ticketId',
    params: {
      ticketId: null, // optional
    },
    component: uploadWarrantComponent.name,
    data: { requiresAuth: true },
    resolve: {
      ticket: TicketService.ticket({ optional: true }),
      maybeRedirectToNewUi: (appConfig, $window, envService) => {
        const { ui } = appConfig;
        if (ui.v2UI.oldBank && !envService.isLocalhost()) {
          $window.location.href = '/v2/transferring/upload';
        }
      },
      stateIndex: () => 0, // First step for a new transferring request ticket
    },
  });
};
